import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/style/style.css'
import store from './store'
import VueTimeago from 'vue-timeago'
import {
  Toast
} from 'vant';
import 'vant/lib/toast/style';
Vue.use(Toast);

import 'lib-flexible' // 移动端适配

Vue.config.productionTip = false
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'zh-CN', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')